import { render } from "./category.vue?vue&type=template&id=56fe4ef4&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"

import "./category.vue?vue&type=style&index=0&id=56fe4ef4&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe4ef4"]])

export default __exports__